import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map, distinctUntilChanged, startWith } from 'rxjs/operators';
import { BlocklyConfigService } from './blockly-config.service';

@Injectable({ providedIn: 'root' })
export class GeneratedCodeService {
  
  private readonly codeSubject$ = new BehaviorSubject<string>('');
  
  readonly generatedCode$ = this.codeSubject$.asObservable();
  
  readonly codeLines$ = this.generatedCode$.pipe(
    map(code => (code ?? '').split('\n'))
  );
  
  readonly isCodePresent$ = this.generatedCode$.pipe(
    map(code => this.configService.shouldMarkCodePresent(code ?? '')),
    distinctUntilChanged(),
    startWith(false)
  );

  constructor(private configService: BlocklyConfigService) {}

  get currentCode(): string {
    return this.codeSubject$.value;
  }

  setCode(code: string): void {
    this.codeSubject$.next(code);
  }

  clearCode(): void {
    this.codeSubject$.next('');
  }
}